import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-purple-50 via-white to-purple-50 border-t border-purple-100 mt-16 relative z-10 pointer-events-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10 pointer-events-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2 lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-primary to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
              <div>
                <h3 className="text-2xl font-bold bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent">
                  ZeroBro
                </h3>
                <p className="text-xs text-gray-600">Find Your Dream Home</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Your trusted platform for finding the perfect property across India. From apartments to villas, we've got you covered.
            </p>
            {/* Social Links */}
            <div className="flex space-x-3 relative z-20">
              <a href="#" className="w-10 h-10 bg-purple-100 hover:bg-purple-200 rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-110 group cursor-pointer">
                <svg className="w-5 h-5 text-primary group-hover:text-purple-700" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-100 hover:bg-purple-200 rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-110 group cursor-pointer">
                <svg className="w-5 h-5 text-primary group-hover:text-purple-700" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-100 hover:bg-purple-200 rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-110 group cursor-pointer">
                <svg className="w-5 h-5 text-primary group-hover:text-purple-700" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.223-.548.223l.188-2.85 5.18-4.68c.223-.198-.054-.308-.346-.11l-6.4 4.02-2.76-.918c-.6-.187-.612-.6.125-.89l10.782-4.156c.5-.176.943.11.78.89z"/>
                </svg>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-100 hover:bg-purple-200 rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-110 group cursor-pointer">
                <svg className="w-5 h-5 text-primary group-hover:text-purple-700" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="relative z-20">
            <h4 className="text-lg font-bold mb-4 text-gray-900">Quick Links</h4>
            <ul className="space-y-2 relative z-20">
              <li>
                <button 
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/');
                  }} 
                  className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer"
                >
                  Browse Properties
                </button>
              </li>
              <li>
                <button 
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/create-property');
                  }} 
                  className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer"
                >
                  List Your Property
                </button>
              </li>
              <li>
                <button 
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/my-properties');
                  }} 
                  className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer"
                >
                  My Properties
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Property Types */}
          <div className="relative z-20">
            <h4 className="text-lg font-bold mb-4 text-gray-900">Property Types</h4>
            <ul className="space-y-2 relative z-20">
              <li>
                <button 
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/?type=apartment');
                  }} 
                  className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer"
                >
                  Apartments
                </button>
              </li>
              <li>
                <button 
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/?type=house');
                  }} 
                  className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer"
                >
                  Houses
                </button>
              </li>
              <li>
                <button 
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/?type=villa');
                  }} 
                  className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer"
                >
                  Villas
                </button>
              </li>
              <li>
                <button 
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/?type=penthouse');
                  }} 
                  className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer"
                >
                  Penthouses
                </button>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="relative z-20">
            <h4 className="text-lg font-bold mb-4 text-gray-900">Support</h4>
            <ul className="space-y-2 relative z-20">
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-purple-200 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            {/* Copyright */}
            <p className="text-gray-600 text-sm">
              © {currentYear} ZeroBro. All rights reserved.
            </p>

            {/* Additional Links */}
            <div className="flex items-center space-x-6 relative z-20">
              <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer">
                Sitemap
              </a>
              <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer">
                Blog
              </a>
              <a href="#" className="text-gray-600 hover:text-primary transition-colors text-sm font-medium cursor-pointer">
                Careers
              </a>
            </div>

            {/* Back to Top */}
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="group flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-primary to-purple-600 text-white rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-200 cursor-pointer relative z-20"
            >
              <span>Back to Top</span>
              <svg className="w-4 h-4 group-hover:-translate-y-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
              </svg>
            </button>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="border-t border-purple-200 pt-6 mt-6">
          <div className="flex flex-wrap items-center justify-center gap-6 text-xs text-gray-600 font-medium">
            <div className="flex items-center space-x-2">
              <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Verified Properties</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              <span>Secure Transactions</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-4 h-4 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
              </svg>
              <span>Trusted by Thousands</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

